import { JSX } from "react";

export const History = (): JSX.Element => {
    return (
        <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 15C6.08333 15 4.41319 14.3646 2.98958 13.0938C1.56597 11.8229 0.75 10.2361 0.541667 8.33333H2.25C2.44444 9.77778 3.08681 10.9722 4.17708 11.9167C5.26736 12.8611 6.54167 13.3333 8 13.3333C9.625 13.3333 11.0035 12.7674 12.1354 11.6354C13.2674 10.5035 13.8333 9.125 13.8333 7.5C13.8333 5.875 13.2674 4.49653 12.1354 3.36458C11.0035 2.23264 9.625 1.66667 8 1.66667C7.04167 1.66667 6.14583 1.88889 5.3125 2.33333C4.47917 2.77778 3.77778 3.38889 3.20833 4.16667H5.5V5.83333H0.5V0.833333H2.16667V2.79167C2.875 1.90278 3.73958 1.21528 4.76042 0.729167C5.78125 0.243056 6.86111 0 8 0C9.04167 0 10.0174 0.197917 10.9271 0.59375C11.8368 0.989583 12.6285 1.52431 13.3021 2.19792C13.9757 2.87153 14.5104 3.66319 14.9062 4.57292C15.3021 5.48264 15.5 6.45833 15.5 7.5C15.5 8.54167 15.3021 9.51736 14.9062 10.4271C14.5104 11.3368 13.9757 12.1285 13.3021 12.8021C12.6285 13.4757 11.8368 14.0104 10.9271 14.4062C10.0174 14.8021 9.04167 15 8 15ZM10.3333 11L7.16667 7.83333V3.33333H8.83333V7.16667L11.5 9.83333L10.3333 11Z"
                fill="#E67A01"
            />
        </svg>
    );
};
